import { Button } from '@consigli/facade';
import { FC, useState } from 'react';
import { IoIosInformationCircleOutline, IoIosClose } from 'react-icons/io';

interface DismissibleDisclaimerProps {
  children: React.ReactNode;
}

export const DismissibleDisclaimer: FC<DismissibleDisclaimerProps> = ({ children }) => {
  const [isDismissed, setIsDismissed] = useState(false);

  const handleDismiss = () => {
    setIsDismissed(true);
  };

  if (isDismissed) {
    return null;
  }

  return (
    <div className="bg-day-light-2 border-b border-day-light-1 px-4 py-3 mt-4 mx-4 rounded-lg">
      <div className="flex items-center gap-3">
        <IoIosInformationCircleOutline
          size={20}
          className="flex-shrink-0 text-day-neutral-subtle"
        />
        <p className="flex-1 text-sm text-day-neutral-dark">{children}</p>
        <Button
          tertiary
          iconOnly
          icon={IoIosClose}
          iconSize={20}
          onClick={handleDismiss}
          title="Dismiss"
          className="flex-shrink-0 hover:bg-day-light-1"
        />
      </div>
    </div>
  );
};
